import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
    const sliderTestimonials = document.querySelectorAll('.slider-testimonials');

    sliderTestimonials.forEach((carouselElement, index) => {
        if (carouselElement) {
            carouselElement.classList.add(`swiper-${index}`);

            const slides = carouselElement.querySelectorAll('.swiper-slide');
            const hasMultipleSlides = slides.length > 1;
            const sliderControls = carouselElement.closest('.slider-wrapper')?.querySelector('.slider-controls');

            // Removes slider control element
            if (!hasMultipleSlides && sliderControls) {
                sliderControls.remove();
            }

            setTimeout(() => {
                const swiper = new Swiper(carouselElement, {
                    modules: [Navigation, Pagination],
                    loop: true,
                    grabCursor: true,
                    slidesPerView: 1,
                    speed: 600,
                    parallax: true,
                    navigation: hasMultipleSlides ? {
                        nextEl: '.slider-next',
                        prevEl: '.slider-prev',
                    } : false,
                    pagination: hasMultipleSlides ? {
                        el: ".slider-pagination",
                        clickable: true
                    } : false,
                });

                // Disables slider controls when only 1 slide is visble
                if (!hasMultipleSlides) {
                    const nextButton = document.querySelector('.slider-next');
                    const prevButton = document.querySelector('.slider-prev');

                    if (nextButton) nextButton.style.display = 'none';
                    if (prevButton) prevButton.style.display = 'none';
                }
            }, 0);
        }
    });
});
